export const LABEL = {
  USER_NAME: 'User Name',
  NAME: "Display Name",
  IDP_PROVIDER: "Identity Provider",
  LAST_LOGIN_AT: "Last Login At",
  EMAIL: "Email",
  DELETE_USER: "Delete User",
  BLOCK_SIGN_IN: "Block Sign In",
  RESET_PASSWORD: "Reset Password",
  SEARCH_USER: 'Search (Min. 3 chars)',
  NO_VALUE: "--",
};

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};

export const ASSIGNED_ROLES = 'Assigned Roles';
export const EDIT_USER = 'Edit User';
export const DELETE_USER = 'Delete User';
export const MANAGE_ROLES = 'Manage Roles';
export const MANAGE_LOCATION = 'Manage Sub-Realms';
export const ACTIONS = 'Actions';
export const DROPDOWN_MAX_HEIGHT = 350;
export const DISPLAY_NAME = 'displayName';
export const USER_NAME = 'userName';
export const LAST_NAME = 'lastName';
export const FIRST_NAME = 'givenName';
export const EMAIL = 'email';
export const FOR = 'for';


